import type { ThemeVersion } from "@/lib/api/types";

/** Highest version number among published versions, or null when none published. */
export function getLatestPublishedVersionNumber(
  versions: ThemeVersion[],
): number | null {
  const published = versions.filter((version) => version.publishedAt !== null);
  if (published.length === 0) {
    return null;
  }
  return published.reduce(
    (max, version) => (version.version > max ? version.version : max),
    published[0].version,
  );
}

/** The most recent DRAFT version (highest version number, not yet published). */
export function getLatestDraftVersion(
  versions: ThemeVersion[],
): ThemeVersion | null {
  const drafts = versions.filter((version) => version.publishedAt === null);
  if (drafts.length === 0) {
    return null;
  }
  return drafts.reduce(
    (latest, version) => (version.version > latest.version ? version : latest),
    drafts[0],
  );
}

/** Versions sorted newest-first for display. */
export function sortVersionsDesc(versions: ThemeVersion[]): ThemeVersion[] {
  return [...versions].sort((a, b) => b.version - a.version);
}
